import { useEffect, useRef, useState } from "react";

export const useSticky = <Target extends HTMLElement>() => {
    const ref = useRef<Target>(null);
    const [isSticky, setIsSticky] = useState(false);
    const delayTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const node = ref.current;
        if (!node) {
            return;
        }

        const handleIntersection = ([entry]: IntersectionObserverEntry[]) => {
            if (delayTimeout.current) {
                clearTimeout(delayTimeout.current);
            }

            delayTimeout.current = setTimeout(() => {
                setIsSticky(entry.intersectionRatio < 1);
            }, 100);
        };

        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 1,
            rootMargin: "0px 0px 0px 0px",
        });

        observer.observe(node);

        return () => {
            if (delayTimeout.current) {
                clearTimeout(delayTimeout.current);
            }
            observer.disconnect();
        };
    });
    // Re-run when the parent re-renders so a ref that materializes after mount is observed.

    return { ref, isSticky };
};
